import React, { useState, Component } from 'react';
import { Container } from '../components/ui/Container';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Shield, CheckCircle } from 'lucide-react';
export function SecurityPolicyPage() {
  const [formData, setFormData] = useState({
    name: '',
    role: '',
    company: '',
    email: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const subject = encodeURIComponent('Flowsense Information Security Policy request');
    const body = encodeURIComponent(`Information Security Policy Request\n\n` + `Name: ${formData.name}\n` + `Role: ${formData.role}\n` + `Company: ${formData.company}\n` + `Email: ${formData.email}\n\n` + `Please send the Flowsense Information Security Policy document to the email address provided above.`);
    window.location.href = `mailto:security@acciom.co.uk?subject=${subject}&body=${body}`;
    setIsSubmitted(true);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <div className="bg-white py-20 lg:py-28" data-id="element-2020">
      <Container size="md" data-id="element-2021">
        <div className="text-center mb-12" data-id="element-2022">
          <div className="inline-flex items-center justify-center p-3 bg-indigo-100 rounded-xl mb-6" data-id="element-2023">
            <Shield className="h-8 w-8 text-indigo-600" data-id="element-2024" />
          </div>
          <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl mb-4" data-id="element-2025">
            Information Security Policy
          </h1>
          <p className="text-xl text-gray-600 mb-2" data-id="element-2026">
            Acciom Limited - Flowsense Platform
          </p>
          <p className="text-sm text-gray-500" data-id="element-2027">
            Last updated: December 15, 2024
          </p>
        </div>

        {!isSubmitted ? <div className="max-w-2xl mx-auto" data-id="element-2028">
            <div className="bg-indigo-50 border-l-4 border-indigo-500 p-6 mb-8" data-id="element-2029">
              <p className="text-sm text-indigo-900 font-semibold mb-2" data-id="element-2030">
                REQUEST ACCESS TO OUR SECURITY POLICY
              </p>
              <p className="text-sm text-indigo-800" data-id="element-2031">
                Our comprehensive Information Security Policy is available upon
                request. Please complete the form below and we'll send you the
                full document via email.
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-8 shadow-sm" data-id="element-2032">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-2033">
                Request Policy Document
              </h2>

              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-2034">
                <div data-id="element-2035">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2036">
                    Full Name *
                  </label>
                  <Input id="name" name="name" type="text" required value={formData.name} onChange={handleChange} placeholder="John Smith" className="w-full" data-id="element-2037" />
                </div>

                <div data-id="element-2038">
                  <label htmlFor="role" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2039">
                    Role / Title *
                  </label>
                  <Input id="role" name="role" type="text" required value={formData.role} onChange={handleChange} placeholder="Chief Technology Officer" className="w-full" data-id="element-2040" />
                </div>

                <div data-id="element-2041">
                  <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2042">
                    Company Name *
                  </label>
                  <Input id="company" name="company" type="text" required value={formData.company} onChange={handleChange} placeholder="Acme Corporation" className="w-full" data-id="element-2043" />
                </div>

                <div data-id="element-2044">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2045">
                    Email Address *
                  </label>
                  <Input id="email" name="email" type="email" required value={formData.email} onChange={handleChange} placeholder="john.smith@acme.com" className="w-full" data-id="element-2046" />
                </div>

                <div className="bg-gray-50 p-4 rounded-lg" data-id="element-2047">
                  <p className="text-sm text-gray-600" data-id="element-2048">
                    By submitting this form, you agree that Acciom Limited may
                    contact you regarding your request. We will send the
                    Information Security Policy document to the email address
                    provided above.
                  </p>
                </div>

                <Button type="submit" size="lg" className="w-full" data-id="element-2049">
                  Request Security Policy
                </Button>
              </form>
            </div>

            <div className="mt-8 bg-gray-50 p-6 rounded-lg" data-id="element-2050">
              <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-2051">
                What's Included in Our Security Policy?
              </h3>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-2052">
                <li className="flex items-start" data-id="element-2053">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2054" />
                  <span data-id="element-2055">
                    Comprehensive governance and organizational structure
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2056">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2057" />
                  <span data-id="element-2058">Data classification and handling procedures</span>
                </li>
                <li className="flex items-start" data-id="element-2059">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2060" />
                  <span data-id="element-2061">Access control and authentication requirements</span>
                </li>
                <li className="flex items-start" data-id="element-2062">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2063" />
                  <span data-id="element-2064">Network and infrastructure security measures</span>
                </li>
                <li className="flex items-start" data-id="element-2065">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2066" />
                  <span data-id="element-2067">
                    Application security and secure development lifecycle
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2068">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2069" />
                  <span data-id="element-2070">
                    Data protection, privacy, and GDPR/CCPA compliance
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2071">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2072" />
                  <span data-id="element-2073">Encryption standards and cryptography practices</span>
                </li>
                <li className="flex items-start" data-id="element-2074">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2075" />
                  <span data-id="element-2076">Backup and disaster recovery procedures</span>
                </li>
                <li className="flex items-start" data-id="element-2077">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2078" />
                  <span data-id="element-2079">
                    Security monitoring and incident response protocols
                  </span>
                </li>
                <li className="flex items-start" data-id="element-2080">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2081" />
                  <span data-id="element-2082">Third-party risk management and vendor assessment</span>
                </li>
                <li className="flex items-start" data-id="element-2083">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2 flex-shrink-0 mt-0.5" data-id="element-2084" />
                  <span data-id="element-2085">
                    Compliance framework (SOC 2, ISO 27001, GDPR, CCPA)
                  </span>
                </li>
              </ul>
            </div>

            <div className="mt-8 text-center" data-id="element-2086">
              <p className="text-sm text-gray-600 mb-4" data-id="element-2087">
                Have questions about our security practices?
              </p>
              <a href="mailto:security@acciom.co.uk" className="text-indigo-600 hover:text-indigo-700 font-medium" data-id="element-2088">
                Contact our Security Team →
              </a>
            </div>
          </div> : <div className="max-w-2xl mx-auto text-center" data-id="element-2089">
            <div className="bg-green-50 border border-green-200 rounded-lg p-8" data-id="element-2090">
              <div className="inline-flex items-center justify-center p-3 bg-green-100 rounded-full mb-6" data-id="element-2091">
                <CheckCircle className="h-12 w-12 text-green-600" data-id="element-2092" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-2093">
                Request Submitted Successfully
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-2094">
                Your email client should have opened with a pre-filled message
                to our Security Team. If it didn't open automatically, please
                send an email to:
              </p>
              <div className="bg-white border border-green-200 rounded-lg p-4 mb-6" data-id="element-2095">
                <p className="font-mono text-sm text-gray-900" data-id="element-2096">
                  security@acciom.co.uk
                </p>
              </div>
              <p className="text-sm text-gray-600 mb-6" data-id="element-2097">
                We'll review your request and send the Information Security
                Policy document to <strong data-id="element-2098">{formData.email}</strong> within 1-2
                business days.
              </p>
              <Button onClick={() => setIsSubmitted(false)} variant="outline" data-id="element-2099">
                Submit Another Request
              </Button>
            </div>
          </div>}
      </Container>
    </div>;
}